import React, { useContext } from "react";
import { VariantContextData } from "../variants/VariantBuilderContext";
import EmbedCampaignSettings from "./EmbedCampaignSettings";
import EmbedRecommendationSettings from "../embed_recommendations/EmbedRecommendationSettings";
import NewEmbedRecommendation from "../embed_recommendations/NewEmbedRecommendation";
import Tooltip from "../shared/Tooltip";

const ElementSettingsEmbed = (props) => {
  const [contextData, builder] = useContext(VariantContextData);
  const element = builder.selected().object;
  const variant = contextData.objects.variant;
  const section = variant.sections[element.section_id];
  const step = variant.steps[section.step_id];

  const embed_recommendations = Object.values(
    variant.embed_recommendations || {}
  ).filter(
    (recommendation) =>
      recommendation.element_id == element.id &&
      recommendation.toBeDeleted !== true
  );

  return (
    <React.Fragment>
      {element.element_type == "embed" && (
        <React.Fragment>
          <EmbedCampaignSettings
            object={element}
            object_type="elements"
            object_id={element.id}
          />

          <div className="col-xs-12">
            <div className="w-full my-5 relative text-black dark:text-white">
              <span className="text-xl">Conditional Embeds:</span>

              <Tooltip
                tooltip={`Use conditions to override the default embed. The first embed that meets the conditions is shown; otherwise the default embed is used.`}
              />
            </div>

            {embed_recommendations.map((embed_recommendation) => {
              return (
                <EmbedRecommendationSettings
                  key={"embed-recommendation-" + embed_recommendation.id}
                  step={step}
                  section={section}
                  element={element}
                  embed_recommendation={embed_recommendation}
                />
              );
            })}
          </div>
          <NewEmbedRecommendation element={element} />
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default ElementSettingsEmbed;
